import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UsersService } from 'src/app/services/users.service';
import { ICredentials, IUser, IError } from '../../../interfaces';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent {
  constructor(public usersService: UsersService, private router: Router, private snackBar: MatSnackBar) {}

  authenticateForm: ICredentials = {
    email: '',
    password: '',
  };
  isLogging: boolean = false;

  hide: boolean = true;

  authenticate() {
    this.isLogging = true;
    this.usersService.authenticate(this.authenticateForm).subscribe(
      (user: IUser) => {
        localStorage.setItem('token', user.token);
        
        if(user.cpf){
          localStorage.setItem('email', user.email);
          localStorage.setItem('cpf', user.cpf);
          localStorage.setItem('name', user.name);
          localStorage.setItem('phone', user.phone || '');
          this.router.navigate(['/painel-pessoa-fisica']);
        }

        if(user.cnpj){
          localStorage.setItem('email',user.email);
          localStorage.setItem('cnpj',user.cnpj);
          localStorage.setItem('phone', user.phone || '');
          this.router.navigate(['/painel-pessoa-juridica']);
        }

        this.isLogging = false;
      },
      (error: IError) => {
        this.snackBar.open("Login invalido", "Fechar", {
          duration: 7000,
        })
        this.isLogging = false;
      }
    );
  }
}
